<template>
  <page>
    <v-flex xs12>
      <form action="">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field
                          v-model="filter.polTypeGrp"
                          :label="labels.polTypeGrp"
                          data-vv-name="polTypeGrp"
                          :data-vv-as="labels.polTypeGrp"
                          :error-messages="errors.collect('polTypeGrp')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field
                          v-model="filter.polTypeGrpDesc"
                          :label="labels.polTypeGrpDesc"
                          data-vv-name="polTypeGrpDesc"
                          :data-vv-as="labels.polTypeGrpDesc"
                          :error-messages="errors.collect('polTypeGrpDesc')"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-1"></v-spacer>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New Policy Type Group
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            :server-items-length="totalItems"
            :loading="loading"
            :no-data-text="noDataText"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.polTypeGrp }}</td>
                <td class="text-xs-left">{{ row.item.polTypeGrpDesc }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview(row.item)"
                    query
                    @query="doQuery(row.item)"
                    remove
                    @remove="doPromptRemove(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>
    <!--Start Dialog Reivew-->
    <v-dialog v-model="reviewDialog" width="800px" persistent>
      <v-card>
        <v-toolbar v-if="queryMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-magnify</v-icon>
          <v-toolbar-title>{{ labels.queryMode }}</v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="reviewMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-magnify</v-icon>
          <v-toolbar-title>{{ labels.reviewMode }}</v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="newMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-plus</v-icon>
          <v-toolbar-title>{{ labels.newMode }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  :label="labels.polTypeGrp"
                  v-model="form.polTypeGrp"
                  :error-messages="errors.collect('polTypeGrp')"
                  data-vv-name="polTypeGrp"
                  :data-vv-as="labels.polTypeGrp"
                  v-validate="'required|param|max:10'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.polTypeGrp }}</v-subheader>
                <div class="queryValue">{{ form.polTypeGrp }}</div>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.polTypeGrpDesc }}</v-subheader>
                <div class="queryValue">{{ form.polTypeGrpDesc }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  :label="labels.polTypeGrpDesc"
                  v-model="form.polTypeGrpDesc"
                  :error-messages="errors.collect('polTypeGrpDesc')"
                  data-vv-name="polTypeGrpDesc"
                  :data-vv-as="labels.polTypeGrpDesc"
                  v-validate="'required|max:30'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ form.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ form.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
          <v-btn v-show="!queryMode" color="primary" text @click.native="doSave" :loading="submitting">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Review Dialog -->
    <!--Start Delete Prompt -->
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>{{ labels.promptRemove }}</p>
      <div class="queryValue">{{ selected.polTypeGrp }} - {{ selected.polTypeGrpDesc }}</div>
    </confirm>
    <!-- End Delete Prompt-->
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { formatDisplayDate } from '@/utils/date'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      toogleArray: [false],
      loading: false,
      submitting: false,
      totalItems: 0,
      headers: [
        { text: 'Policy Type Group', value: 'polTypeGrp' },
        { text: 'Policy Type Group Description', value: 'polTypeGrpDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        polTypeGrp: 'Policy Type Group',
        polTypeGrpDesc: 'Policy Type Group Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        queryMode: 'Query Policy Type Group',
        reviewMode: 'Edit Policy Type Group',
        newMode: 'Create New Policy Type Group',
        promptRemove: 'Are you sure you want to delete the selected Policy Type Group?'
      },
      form: {
        polTypeGrp: null,
        polTypeGrpDesc: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      selected: {
        polTypeGrp: null,
        polTypeGrpDesc: null
      },
      filter: {
        polTypeGrp: undefined,
        polTypeGrpDesc: undefined
      },
      promptRemove: false,
      queryMode: false,
      reviewMode: false,
      reviewDialog: false,
      newMode: false,
      today: new Date(),
      getMenu: {},
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    // await this.$store.dispatch('initPolTypeGrp')
    this.fetchData(true)
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      const apiURI = this.menu.initPolTypeGrp
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result
          if (data) {
            this.getMenu = extractMenu(data._links)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.getMenu.getPolTypeGrpList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  polTypeGrp: datamap.polTypeGrp,
                  polTypeGrpDesc: datamap.polTypeGrpDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.form.polTypeGrp = null
      this.form.polTypeGrpDesc = null
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
      this.form.modifiedBy = null
      this.form.modifiedDate = null
      this.queryMode = false
      this.reviewMode = false
      this.newMode = true
      this.reviewDialog = true
    },
    doQuery(data) {
      this.queryMode = true
      this.reviewMode = false
      this.newMode = false
      this.doFetchData(data)
    },
    doReview(data) {
      this.queryMode = false
      this.newMode = false
      this.reviewMode = true
      this.doFetchData(data)
    },
    doFetchData(data) {
      this.resetValidator()
      this.resetMessages()
      if (data) {
        const apiURI = this.getMenu.getPolTypeGrp
        const expand = {
          polTypeGrp: data.polTypeGrp,
          polTypeGrpDesc: data.polTypeGrpDesc
        }
        if (apiURI) {
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.form.polTypeGrp = data.polTypeGroupDto.polTypeGrp
                this.form.polTypeGrpDesc = data.polTypeGroupDto.polTypeGrpDesc
                this.form.createdBy = data.createdBy
                this.form.createdDate = data.createdDate
                this.form.modifiedBy = data.modifiedBy
                this.form.modifiedDate = data.modifiedDate
                this.reviewDialog = true
              }
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.getMenu.checkDeletePolTypeGrp
          const expand = {
            polTypeGrp: data.polTypeGrp
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selected.polTypeGrp = data.polTypeGrp
          this.selected.polTypeGrpDesc = data.polTypeGrpDesc
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.polTypeGrp) {
        const apiURI = this.getMenu.deletePolTypeGrp
        if (apiURI) {
          const expand = {
            polTypeGrp: this.selected.polTypeGrp,
            polTypeGrpDesc: this.selected.polTypeGrpDesc
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.form.polTypeGrp = null
      this.form.polTypeGrpDesc = null
      this.reviewDialog = false
      setTimeout(() => {
        this.newMode = false
        this.queryMode = false
        this.reviewMode = false
      }, 200)
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          } else {
            // doNothing here
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.getMenu.createPolTypeGrp
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClose()
            this.fetchData(false)
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.getMenu.updatePolTypeGrp
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClose()
            this.fetchData(false)
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.polTypeGrp = undefined
      this.filter.polTypeGrpDesc = undefined
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.resetValidator()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  computed: {
    menu() {
      return this.$store.state.polTypeParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
